/* eslint-disable no-undef */

import React, {Component} from 'react'
import {withStyles} from '@material-ui/core/styles/index'
import {
    Grid,
    TextField,
    FormHelperText,
    InputAdornment,
    Select,
    InputLabel,
    FormControl,
    MenuItem,
    Box,
    Chip,
    Divider,
    CardContent, CardMedia, Card, Typography
} from '@material-ui/core'
import SliderQuestion from "./Slider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {getExpenses, removeUploadedFile} from "../../../api";
import { withTranslation } from 'react-i18next'


const styles = theme => ({
    questionWrapper: {
        marginTop: '0px!important',
        ...theme.isMobile && {
            padding: '4px!important'
        },
    },
    titleRow: {
        display: 'flex',
        flexWrap: 'wrap',
        wordBreak: 'break-all',
        paddingTop: theme.spacing(0.5)
    },
    titleWrapper: {
        flexGrow: 1,
        alignItems: 'center',
        display: 'flex',
        ...theme.isMobile && {
            //width: '100%'
        }
    },
    title: {
        textAlign: 'left!important',
        marginTop: `0px!important`,
        marginRight: theme.spacing(1)
    },
    priceWrapper: {
        alignItems: 'center',
        display: 'flex'
    },
    price: {
        textAlign: 'right!important',
        marginTop: `0px!important`,
        color: theme.palette.primary.main + '!important',
    },
    smallPrice: {},
    chip: {
        color: 'rgba(0, 0, 0, 0.61)',
        backgroundColor: '#eeeeee',
        fontWeight: 600,
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(0.75),
        '&:last-child': {
            marginRight: 0
        }
    },
    chipIcon: {
        marginLeft: theme.spacing(1) + 'px!important'
    },
    smallDescription: {
        color: 'rgba(0,0,0,0.61)',
        fontSize: '1rem'
    },
    dividerWrapper: {
        opacity: 0.75
    },
    cardTitle: {
        fontSize: '1.05rem!important'
    },
    cardDescription: {
        fontSize: '0.95rem!important'
    }
})

const numberFormat = number => {
    return number ? String(Number(Math.round(number * 100) / 100)).replace('.', ',') : 0
}

class OfferQuestion extends Component {
    state = {
        originalPrice: null,
        expences: null,
        paid: null,
    }

    handleChange = value => {
        this.props.onValueChanged(this.props.question.id, value)
    }

    componentDidMount() {
        getExpenses(this.props.visitorSessionId)
            .then((data) => {
                if(data.originalPrice){
                    this.setState({
                        originalPrice: data.originalPrice,
                        expences: data.expences,
                        paid: data.paid,
                    })
                }
            })
            .catch(err => alert(err))

        setTimeout(() => {
            this.handleChange('Ok')
        }, 100)
    }

    render() {
        const {classes, value, question, theme, t} = this.props
        const {originalPrice, expences, paid} = this.state

        return (
            <Grid item xs={parseInt(question.xsCols)} sm={parseInt(question.smCols)} className={classes.questionWrapper}>
                <Box className={classes.root} mb={2}>
                    <Card className={classes.card} variant="outlined">
                        <CardContent>
                            <Box mt={0.5}>
                                <Typography gutterBottom variant="body2" component="p" className={classes.cardTitle}>
                                    <b>{t('Alustava tarjous')}</b>
                                </Typography>
                            </Box>
                            <Box mt={2} mb={2} mx={-2} className={classes.dividerWrapper}>
                                <Divider variant="middle"/>
                            </Box>
                            <Box className={classes.titleRow}>
                                <Box className={classes.titleWrapper}>
                                    <Typography gutterBottom variant="body2" component="p">
                                        {t('Laskun summa')} <small>{t('alv')} 24%</small>
                                    </Typography>
                                </Box>
                                <Box className={classes.priceWrapper}>
                                    <Typography gutterBottom variant="h5" component="h3" className={classes.price + ' ' + classes.smallPrice}>
                                        {originalPrice ? numberFormat(originalPrice) + ' €' : '...'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className={classes.titleRow}>
                                <Box className={classes.titleWrapper}>
                                    <Typography gutterBottom variant="body2" component="p">
                                        {t('Kulut')}
                                    </Typography>
                                </Box>
                                <Box className={classes.priceWrapper}>
                                    <Typography gutterBottom variant="h5" component="h3" className={classes.price + ' ' + classes.smallPrice}>
                                        {expences ? numberFormat(expences) + ' €' : '...'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className={classes.titleRow}>
                                <Box className={classes.titleWrapper}>
                                    <Typography gutterBottom variant="body2" component="p">
                                        <b>{t('Maksetaan tilillesi')}</b> <small>{t('alv')} 24%</small>
                                    </Typography>
                                </Box>
                                <Box className={classes.priceWrapper}>
                                    <Typography gutterBottom variant="h5" component="h3" className={classes.price}>
                                        {paid ? numberFormat(paid) + ' €' : '...'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box mt={1.5} mb={2.5} mx={-2} className={classes.dividerWrapper}>
                                <Divider variant="middle"/>
                            </Box>
                            <Box mb={-0.5}>
                                <Typography variant="body2" component="p" className={classes.cardDescription}>
                                    {t('Hakemuksen lähettämisen jälkeen saat rahoitusyhtiöltä hyväksyttäväksi lopullisen tarjouksen ja sopimuksen.')}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
        )
    }
}

export default withTranslation()(withStyles(styles)(OfferQuestion))
